export const redirectUriList = {
  local: 'http://localhost:1234/login/token',
  dev: 'https://dev-portal.safholland.com/login/token',
  stage: 'https://stage-portal.safholland.com/login/token',
  live: 'https://portal.safholland.com/login/token',
}
